import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { Component } from "react";
import { GoogleReCaptcha } from "react-google-recaptcha-v3";
import * as Yup from "yup";

const ResponseSchema = Yup.object().shape({
    author_name: Yup.string().required("Het veld 'Uw naam' is niet goed ingevuld."),
    author_email: Yup.string()
        .email("Het veld 'Uw e-mailadres' is niet goed ingevuld.")
        .required("Het veld 'Uw e-mailadres' is niet goed ingevuld."),
    response: Yup.string().required("Het veld 'Uw bericht' is niet goed ingevuld.")
});

export default class BulletboardResponseForm extends Component {
    constructor(props) {
        super(props);
        this.state = { recaptcha: false };

        this.handleRecaptchaVerify = this.handleRecaptchaVerify.bind(this);
    }

    handleRecaptchaVerify() {
        this.setState({
            recaptcha: true
        });
    }

    render() {
        if (this.props.item === null) {
            return null;
        }

        return (
            <div>
                <Formik
                    initialValues={{
                        author_name: "",
                        author_email: "",
                        response: "",
                        item_id: this.props.item.id
                    }}
                    validationSchema={ResponseSchema}
                    onSubmit={(values, { resetForm }) => {
                        if (this.state.recaptcha) {
                            this.props
                                .onSubmit(values)
                                .then(() => {
                                    resetForm({});
                                })
                                .catch(errors => {
                                    console.error(errors);
                                });
                        }
                    }}
                >
                    {({
                        errors,
                        isSubmitting,
                        handleBlur,
                        isValid,
                        touched
                    }) => (
                        <Form
                            className={
                                isSubmitting
                                    ? "form form--loading form__wrapper"
                                    : "form form--ready form__wrapper"
                            }
                        >
                            {this.props.successMessage !== null ? (
                                <div className="message message--success">
                                    {this.props.successMessage}
                                </div>
                            ) : null}
                            {this.props.errorMessage ? (
                                <div className="message">
                                    {this.props.errorMessage}
                                </div>
                            ) : null}
                            <div className="field__row">
                                <h3 className="form__title">
                                    Reageer op deze advertentie
                                </h3>
                                <i>alle velden zijn verplicht</i>
                            </div>
                            <div className="field__row field__row--labels-top">
                                <label
                                    htmlFor="author_name"
                                    className="field__label"
                                >
                                    Uw naam
                                </label>
                                <div className="field__wrapper">
                                    <Field
                                        onBlur={handleBlur}
                                        className={
                                            errors.author_name &&
                                            touched.author_name
                                                ? "field field--error"
                                                : "field"
                                        }
                                        id="author_name"
                                        name="author_name"
                                        placeholder="Voornaam Achternaam"
                                        aria-describedby={errors.author_name && touched.author_name ? 'author_name_error' : null}
                                        aria-required="true"
                                        aria-invalid={errors.author_name && touched.author_name ? 'true' : null}
                                        autoComplete="name"
                                    />
                                    <div role="status">
                                        <ErrorMessage name="author_name">
                                            {msg => (
                                                <div className="field__error-message" id="author_name_error">
                                                    {msg}
                                                </div>
                                            )}
                                        </ErrorMessage>
                                    </div>
                                </div>
                            </div>

                            <div className="field__row field__row--labels-top">
                                <label
                                    htmlFor="author_email"
                                    className="field__label"
                                >
                                    Uw e-mailadres
                                </label>
                                <div className="field__wrapper">
                                    <Field
                                        className={
                                            errors.author_email &&
                                            touched.author_email
                                                ? "field field--error"
                                                : "field"
                                        }
                                        type="email"
                                        id="author_email"
                                        name="author_email"
                                        placeholder="mail@example.com"
                                        aria-describedby={errors.author_email && touched.author_email ? 'author_email_error' : null}
                                        aria-required="true"
                                        aria-invalid={errors.author_email && touched.author_email ? 'true' : null}
                                        autoComplete="email"
                                    />
                                    <div role="status">
                                        <ErrorMessage name="author_email">
                                            {msg => (
                                                <div className="field__error-message" id="author_email_error">
                                                    {msg}
                                                </div>
                                            )}
                                        </ErrorMessage>
                                    </div>
                                </div>
                            </div>

                            <div className="field__row field__row--labels-top">
                                <label
                                    htmlFor="response"
                                    className="field__label"
                                >
                                    Uw bericht
                                </label>
                                <div className="field__wrapper">
                                    <Field
                                        className={
                                            errors.response && touched.response
                                                ? "field field--error"
                                                : "field"
                                        }
                                        id="response"
                                        name="response"
                                        placeholder="Bericht"
                                        component="textarea"
                                        aria-describedby={errors.response && touched.response ? 'response_error' : null}
                                        aria-required="true"
                                        aria-invalid={errors.response && touched.response ? 'true' : null}
                                    />
                                    <div role="status">
                                        <ErrorMessage name="response">
                                            {msg => (
                                                <div className="field__error-message" id="response_error">
                                                    {msg}
                                                </div>
                                            )}
                                        </ErrorMessage>
                                    </div>
                                </div>
                            </div>

                            {isValid && touched ? (
                                <GoogleReCaptcha
                                    onVerify={this.handleRecaptchaVerify}
                                ></GoogleReCaptcha>
                            ) : null}
                            <div className="buttons">
                                <button
                                    className="button button--small button--primary"
                                    type="submit"
                                    disabled={!isValid}
                                >
                                    {isSubmitting
                                        ? "Versturen..."
                                        : "Reageer op deze advertentie"}
                                </button>
                                <button
                                    className="button button--small button--secondary"
                                    type="reset"
                                    onClick={e => this.props.onCancel(e)}
                                >
                                    Annuleren
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        );
    }
}
